<mat-form-field>
	<mat-label>{{ label }}</mat-label>
	<mat-chip-grid #chipList class="mat-chip-list">
		@for (item of selectedItems; track item) {
			<mat-chip-row (removed)="removeValue(item)">
				{{item.label}}
				<button matChipRemove>
					<mat-icon fontSet="fal" fontIcon="fa-times" />
				</button>
			</mat-chip-row>
		}
		<input matInput
			[placeholder]="placeholder"
			[(ngModel)]="inputValue"
			#input
			#matInput="matInput"
			autocompleteOff
			[validation]="validation"
			[ignoreFormValidation]="validation ? false : true"
			[matAutocomplete]="auto"
			[matChipInputFor]="chipList"
			[matChipInputAddOnBlur]="false"
			[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			(focus)="ngModel.control.markAsTouched()"
			(focusout)="resetInput(true)"
			(ngModelChange)="filterSelectList($event)"
			(matChipInputTokenEnd)="tryAddValue($event.value)">
	</mat-chip-grid>
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="addValue($event.option.viewValue)">
		@if (showOptions()) {
			@for (item of filteredUnusedItems; track item) {
				<mat-option [value]="item.value" (mousedown)="$event.preventDefault()">
					{{item.name}}
				</mat-option>
			}
		}
	</mat-autocomplete>
	<mat-error>{{ 'validation.' + validationMessage | translate }}</mat-error>
	@if (showOptions() && filteredUnusedItems.length === 0 && matInput.focused) {
		<mat-hint>{{ 'general.no-results' | translate }}</mat-hint>
	}
</mat-form-field>
